<template>
  <div class="panel-item">
    <div class="title_name" style="display: flex; justify-content: space-between;">
      <div>{{name}}达人销售排行</div>
    </div>
    <dv-scroll-board :config="config" class="panel-item_datav"/>
  </div>
</template>

<script>

export default {
  components: {},
  props: {
    name: {
      type: String,
      default: ''
    },
    datas: {
      type: Array,
      default: () => []
    },
  },
  data() {
    return {
      config: {
        header: ['排名', '达人昵称', '付款订单'],
        data: [],
        headerBGC: '#053355',
        oddRowBGC: 'transparent',
        evenRowBGC: 'transparent',
        headerHeight: 30,
        hoverPause: true,
        // waitTime: 99999999,
        align: ['left', 'center', 'center'],
        columnWidth: [60,240,100] // 调整列宽，中间列为产品名称宽度

      },
      detailVisible: false,
      detail: {},

    }
  },
  mounted() {
  },
  methods: {},
// 修改 watch 中的 datas 处理逻辑
  watch: {
    datas: {
      immediate: true,
      handler(newVal) {
        const newData = newVal.map((item, index) => [
          `<div class="index${index} left_box">${index > 2 ? index + 1 : ''}</div>`,
          // 为产品名称添加 title 属性，鼠标悬浮时显示完整名称
          `<div title="${item.customer_nickname || ''}">${item.customer_nickname || ''}</div>`,
          `<div class="right_box" style="
          background:#00BAFF;
          font-weight:bold;
          color:#06162A;
        ">${item.count_order || '0'}</div>`
        ])

        this.config = Object.assign({}, this.config, {
          data: newData
        })
      }
    },
  }

}
</script>

<style lang="scss" scoped>
// 在 <style> 部分添加以下样式
::v-deep .ceil:nth-child(2) div {
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

.title_name {
  padding: 30px 0 23px 100px;
  font-weight: 400;
  font-size: 22px;
  color: #FFFFFF;
}


.panel-item {
  width: 490px;
  height: 420px;
  background: url(../../../../assets/_s-image_sector_bg.png) no-repeat;
  background-size: 100% 100%;

  &.first-panel {
    margin: 30px 0 35px 0;
  }
}

.panel-item_datav {
  padding: 0 30px 30px 30px;
  width: 426px;
  height: 290px;
}


::v-deep .header {
  // background: #053355 !important;
  // height: 38px !important;
  // line-height: 38px !important;
  color: #fff; // Added for better visibility
  font-weight: bold;
  font-weight: 400;
  font-size: 18px;
  color: #FFFFFF;
}

::v-deep .header-item {
  // height: 38px !important;
  // line-height: 38px !important;
  font-size: 18px;
}

::v-deep .row-item {

  height: 51px;
  line-height: 52px;
  color: #eee; // Added for better visibility
  font-size: 18px;
  border-bottom: 1px dashed rgba(255, 255, 255, .2);

}

::v-deep .ceil {
  text-align: center;
  // height: 51px !important;
  // line-height: 51px !important;
  padding: 0 10px;
  font-size: 18px;
}

::v-deep .index0 {
  margin-top: 10px;
  height: 34px;
  width: 30px;
  background: url(../../../../assets/ranking1.png) !important;
  background-size: 30px 34px !important;
}

::v-deep .index1 {
  margin-top: 10px;
  height: 34px;
  width: 30px;
  background: url(../../../../assets/ranking2.png) !important;
  background-size: 30px 34px !important;
}

::v-deep .index2 {
  line-height: 34px;
  margin-top: 10px;
  height: 34px;
  width: 30px;
  background: url(../../../../assets/ranking3.png) !important;
  background-size: 30px 34px !important;
}

::v-deep .left_box {
  line-height: 36px !important;
  margin-top: 10px;
  height: 34px;
  width: 30px;
  background: url(../../../../assets/ranking.png);
  background-size: 30px 34px;
}

::v-deep .right_box {
  width: 80%;
  height: 24px;
  line-height: 24px;
  background: #00BAFF;
  font-weight: bold;
  color: #06162A;
  transform: translate(10%, 60%);
}
</style>